<template>
  <div v-loading="loading" class="page-wrap">
    <div class="header">
      <el-button @click="downloadExcel">
        Excel export
        <img style="margin-left: 5px" src="@/assets/images/icons/file-download.svg" alt="">
      </el-button>
      <el-upload
          ref="uploadRef"
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeader"
          :multiple="false"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :limit="1"
          :on-exceed="onExceed"
          :on-success="onSuccessUpload"
          :on-error="onErrorUpload"
      >
        <template #trigger>
          <el-button style="width: 100%" type="warning">
            Excel fayldan yangilash
          </el-button>
        </template>
      </el-upload>
      <router-link to="customer/add" class="el-button el-button--primary">
        Qo'shish
      </router-link>
    </div>
    <el-table
        :data="customers"
        class="table"
        border
        height="calc(100vh - 235px)"
    >
      <el-table-column type="index" :index="indexMethod" width="80" label="#"/>
      <el-table-column prop="title" min-width="190" label="Nomi"/>
      <el-table-column prop="tin" min-width="90" label="Inn"/>
      <el-table-column prop="type" min-width="190" label="Turi">
        <template #default="scope">
          {{ customerTypesObject[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="" width="200" align="center">
        <template #default="scope">
          <el-button
              type="primary"
              size="small"
              @click="
              $router.push({
                name: 'CustomerFormEdit',
                params: { id: scope.row.id },
              })
            "
          >Tahrirlash
          </el-button>
          <el-button
              type="danger"
              size="small"
              @click="onClickDelete(scope.row.id)">
            O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="page"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import {customerTypesObject} from "@/utils/static-values";
import http from "@/http";

export default {
  name: "RoadView",
  computed: {
    customerTypesObject() {
      return customerTypesObject
    }
  },
  data() {
    return {
      loading: false,
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/customers/excel`,
      uploadHeader: {Authorization: `${this.$store.state.accessToken}`},
      customers: [],
      totalElements: 0,
      totalPages: null,
      size: 15,
      page: 1,
    }
  },
  methods: {
    onExceed(files) {
      console.log("exceeds", files);
    },
    downloadExcel(){
      this.loading = true;
      this.$http
          .get(`api/v1/customers/excel`, {
            responseType: "blob",
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(() => {
            ElNotification({
              title: "Ogohlantirish",
              message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }
      ElNotification({
        title: "Xatolik",
        message: "Ma'lumot yuklashda xatolik sodir bo'ldi!",
        type: "error",
      });
      this.loading = false;
    },
    onSuccessUpload() {
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getCustomers()
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/customers/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Muvaffaqqiyatli o'chirildi",
                  });
                  this.getCustomers();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },
    handleSizeChange() {
      this.page = 1;
      this.getCustomers()
    },
    handleCurrentChange() {
      this.getCustomers()
    },
    getCustomers() {
      this.loading = true;

      this.$http
          .get(`api/v1/customers`, {
            params: {
              limit: this.size,
              offset: (this.page - 1) * this.size,
            },
          })
          .then(({data}) => {
            this.customers = data.data;
            this.totalElements = data.count;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.size + 1
    },
  },
  mounted() {
    this.getCustomers()
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: right;
  gap: 5px;

}

.el-button--primary {
  text-decoration: none;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
